(function () {
    'use strict';

    angular.module('UndergroundWebApp').controller('ContainerItemTypesController', ContainerItemTypesController);

    ContainerItemTypesController.$inject = [
        '$scope',
        '$kWindow',
        '$translate',
        'containerItemTypesService',
        'filterStateService',
        'formTypes',
        'statusOptions',
    ];

    function ContainerItemTypesController(
        $scope,
        $kWindow,
        $translate,
        containerItemTypesService,
        filterStateService,
        formTypes,
        statusOptions
    ) {
        $scope.openNewContainerItemType = openNewContainerItemType;
        $scope.openUpdateContainerItemType = openUpdateContainerItemType;
        $scope.deleteContainerItemType = deleteContainerItemType;

        $scope.containerItemTypeOverviewGridOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: readContainerItemTypes
                },
                pageSize: 70,
                sort: filterStateService.getSortFromQueryString(),
                filter: filterStateService.getFilterFromQueryString(),
            }),
            columns: [
                {
                    field: 'name',
                    title: $translate.instant('G_NAME')
                },
                {
                    field: 'edit',
                    filterable: false,
                    sortable: false,
                    groupable: false,
                    title: ' ',
                    width: '80px',
                    template: '<i class="fa fa-1-5x fa-pencil fa-fw" ng-click="openUpdateContainerItemType(dataItem)" aria-hidden="true"></i>' +
                        '<i class="fa fa-1-5x fa-trash fa-fw" ng-click="deleteContainerItemType(dataItem)" aria-hidden="true"></i>'
                }
            ],
            scrollable: {
                virtual: true
            },
            sortable: true,
            filterable: true,
            noRecords: true,
            resizable: true,
            selectable: false,
            sort: filterStateService.storeGridSortInQueryString,
            filter: filterStateService.storeGridFilterInQueryString,
        };

        function readContainerItemTypes(e) {
            $scope.showBusyIndicator();
            containerItemTypesService
                .getContainerItemTypes()
                .then(
                    containerItemTypes => {
                        const itemTypes = _.chain(containerItemTypes)
                            .filter(f => f.status === statusOptions.active.Id)
                            .sortBy(f => f.name)
                            .value();
                        e.success(itemTypes);
                    },
                    () => e.success([])
                )
                .finally(() => $scope.hideBusyIndicator());
        }

        function openNewContainerItemType() {
            openContainerTypeModal($translate.instant('ADMINISTRATION_CONTAINERITEMTYPE_NEW_CONTAINERITEMTYPE'), formTypes.add);
        }

        function openUpdateContainerItemType(dataItem) {
            openContainerTypeModal($translate.instant('ADMINISTRATION_CONTAINERITEMTYPE'), formTypes.edit, dataItem);
        }

        function deleteContainerItemType(dataItem) {
            let confirmText = $translate.instant('ADMINISTRATION_CONTAINERITEMTYPE_DIALOG_CONFIRM_DELETE');

            if (confirm(`${confirmText} ${dataItem.name}?`)) {
                dataItem.status = statusOptions.deleted.Id;
                containerItemTypesService.updateContainerItemType(dataItem).then(() => {
                    $('#container-item-types-grid').getKendoGrid().dataSource.read();
                });
            }
        }

        function openContainerTypeModal(title, formType, containerItemType) {
            return $kWindow.open({
                options: {
                    modal: true,
                    movable: false,
                    title: title,
                    resizable: false,
                    height: 170,
                    width: 400,
                    visible: false
                },
                templateUrl: 'app/administration/containerItemType/container-item-type-details-modal-view.html',
                windowTemplateUrl: 'app/shared/modal-base.html',
                controller: 'ContainerItemTypeDetailsModalController',
                resolve: {
                    currentFormType: () => formType,
                    containerItemType: () => containerItemType
                }
            });
        }
    }
})();
